import type { FC } from "react";
import type { ContentFileDto, Platform } from "shared";
import { Modal, useModal } from "../common/modal/Modal";
import { Button } from "../components/Button";
import { PostPreviewContainer } from "./PostPreviewContainer";
import "./ModalPostPreview.css";

interface ModalPostPreviewProps {
	content: string;
	files: ContentFileDto[];
	initialPlatform?: Platform;
	thumbnailFile?: ContentFileDto;
}

export const ModalPostPreview: FC<ModalPostPreviewProps> = ({
	content,
	files,
	initialPlatform,
	thumbnailFile,
}) => {
	const { close } = useModal();

	return (
		<Modal size="lg" className="modal-post-preview">
			<h5 className="mb-3">Post Preview</h5>
			<p className="text-muted mb-4">
				See how your post will appear on different social media platforms.
			</p>

			<PostPreviewContainer
				content={content}
				files={files}
				initialPlatform={initialPlatform}
				thumbnailFile={thumbnailFile}
			/>

			<div className="mt-4">
				<Button variant="ghost" onClick={close} full>
					Close
				</Button>
			</div>
		</Modal>
	);
};
